<div class="calendar-header-container p-8">
  <div class="header-left">
    <button kendoButton themeColor="primary" (click)="navigate('today')" fillMode="solid">Today</button>
    <div class="ml-16 navigation-wrapper">
      <button kendoButton themeColor="light" class="bg-white" fillMode="solid" iconClass="fa fa-caret-left"
        (click)="navigate('prev')"></button>
      <kendo-gridlayout [rows]="['auto']" [gap]="{ rows: 5, cols: 20 }" [cols]="['repeat(1,minmax(0,1fr))']">
        <kendo-gridlayout-item class="mb-0">
          <div class="kendo-formfield">
            <kendo-datepicker [value]="selectedDate" (valueChange)="onDateChange($event)" calendarType="classic"
              formatPlaceholder="formatPattern" [fillMode]="'outline'" [format]="'MMMM dd, yyyy'">
            </kendo-datepicker>
          </div>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
      <button kendoButton themeColor="light" class="bg-white" fillMode="solid" iconClass="fa fa-caret-right"
        (click)="navigate('next')"></button>
    </div>

  </div>

  <div class="header-right navbar-view-selection">
    <kendo-buttongroup selectionMode="single" class="ml-12">
      <button *ngFor="let view of calendarViews" kendoButton [selected]="selectedViewIndex === view.value"
        (click)="onCalendarViewChanges(view.value)" themeColor="light" class="bg-white" fillMode="solid">
        {{ view.text }}
      </button>
    </kendo-buttongroup>
  </div>
</div>
